import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import Checkbox from "../../FormElement/Checkbox";

interface IHookFormCheckboxProps extends React.ComponentProps<"input"> {
  name: string;
  label?: string;
}

export const HookFormCheckbox = (props: IHookFormCheckboxProps) => {
  const { name, label } = props;

  const { control } = useFormContext();

  return (
    <div className="hook-form-checkbox">
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Checkbox
            checked={field.value}
            id={name}
            label={label}
            onChange={field.onChange}
          />
        )}
      />
    </div>
  );
};
